import 'jquery';
/**
 * @see https://developers.google.com/identity/gsi/web/guides/use-one-tap-js-api?hl=de
 * @see https://developers.google.com/identity/gsi/web/reference/js-reference?hl=de
 *
 */

(function ($, google) {
  let form = $('form[data-with-google]'),
    button = $('div[data-google-one-tap]'),
    body = $('body'),
    lang = $('html').attr('lang'),
    // https://developers.google.com/identity/gsi/web/guides/client-library?hl=de
    script = 'https://accounts.google.com/gsi/client',
    method,
    clientId;
  if (!button.length || !form.length) {
    return;
  }
  // data = button.data('google-one-tap');
  clientId = form.data('with-google');
  // https://developers.google.com/identity/gsi/web/reference/js-reference?hl=de#context
  method = (form.data('sso-method') === 'LOGIN' ? 'signin' : 'signup');

  /**
   * We catch the response
   * @see https://piraces.dev/posts/how-to-use-google-one-tap/
   */
  body.on('plenigo.googleOneTapResult', function (event, result) {
    console.log('back from google', result);
    if (typeof result.credential !== 'undefined') {
      // put complete response into form
      form.find('input[data-google-credentials]').val(JSON.stringify(result));
      // submit form
      form.submit();
      return;
    }

    if (typeof result.getNotDisplayedReason === 'string') {
      let url = new URL(location.href);
      url.searchParams.set('notDisplayedReason', result.getNotDisplayedReason);
      location.href = url.toString();
      return;
    }

  });

  /**
   * we initialize google stuff in outside SDK
   */
  body.trigger('plenigo.googleOneTapInit', {
    lib: script,
    clientId: clientId || '',
    method: button.data('method') || 'login',
  });

  /**
   * we initialie our account at google
   */
  google.accounts.id.initialize({
    client_id: clientId,
    auto_select: true,
    native_callback: function (response) {
      console.log('native callback', response);
    },
    context: method,
    cancel_on_tap_outside: true,
    ux_mode: 'popup',
    callback: function (response) {
      console.log('callback', response);
    },
  });

  button.on('click', function () {
    body.trigger('plenigo.googleOneTapPrompt', {
      lib: script,
      lang: lang,
      clientId: clientId || '',
      method: button.data('method') || 'login',
    });
  });

  /**
   * we create the button
   * @see https://developers.google.com/identity/gsi/web/reference/js-reference?hl=de#GsiButtonConfiguration
   */
  google.accounts.id.renderButton(button.get(0), {
    type: 'standard',
    theme: 'outline', // outline | filled_blue | filled_black
    shape: 'rectangular',
    width: button.width(),
    locale: lang,
    text: button.data('google-one-tap'),
    logo_alignment: 'left',
    size: 'large',
    click_listener: function () {
      body.trigger('plenigo.googleOneTapPrompt', {
        lib: script,
        clientId: clientId || '',
        method: button.data('method') || 'login',
      });
    },
  });

}(jQuery, (window.google || null)));